










































































































































































































































































import moment from "moment/moment";
import Component, { mixins } from "vue-class-component";
import { Site } from "@/shared/Site";
import MobileMixin from "@/mixins/mobileMixin";
import CodeDial from "@/ui-component/CodeDial.vue";
import AutoBackup from "./autobackup.vue";
import ErrorMixin from "@/mixins/errorMixins";

@Component({
  components: { CodeDial, AutoBackup },
})
export default class BDD extends mixins(MobileMixin, ErrorMixin) {
  public validated = false;
  public showCodeDial = false;
  public chooseFile = false;
  public showAutoBackup = false;
  public chooseFileExisting = false;
  public showChooseEmpty = false;
  public showVidagePartiel = false;
  public files = new Array();
  public siteError = false;
  public commError = false;
  public menu: boolean = false;
  public showConfirm = false;
  public dates = [
    new Date().toISOString().substr(0, 10),
    new Date().toISOString().substr(0, 10),
  ];
  public action = "";
  public restaureData = { path: "backup", file: "", fname: "" };
  public vidagePartielData = {
    site: -1,
    debut: "",
    fin: "",
    commentaire: "",
  };

  /**
   * methode d'affichage de la date de debut et de fin dans le selecteur du range picker
   */
  public getDatesStr(date: Date) {
    return moment(date).format("DD/MM/YYYY");
  }

  public updateFileName(file: any) {
    console.log("choose", file);
    this.restaureData.file = this.restaureData.path + "/" + file;
  }
  /**
   * methode de fermeture du datepicker
   */
  public closeDatePicker(show: boolean) {
    if (!show && this.dates[1] === undefined) {
      this.dates[1] = this.dates[0];
    }
    this.vidagePartielData.debut = this.dates[0];
    this.vidagePartielData.fin = this.dates[1];
    // console.log(this.dates);
  }
  /**
   * methode de validation du contrecode permettant de sécuriser certaines actions
   */
  public validateCode(evt: any) {
    this.validated = evt;
    this.showCodeDial = !evt;
    switch (this.action) {
      case "restaure":
        this.chooseRestaure();
        break;
      case "vider":
        this.showChooseEmpty = true;
        break;
    }
  }
  /**
   * methode d'affichage du dialogue de choix du type de vidage
   */
  public emptyBase() {
    this.action = "vider";
    this.validated = false;
    this.showCodeDial = true;
    this.vidagePartielData.debut = this.dates[0];
    this.vidagePartielData.fin = this.dates[1];
  }
  /**
   * methode permettant de valider le vidage de la base de données
   */
  public confirmEmptyBase() {
    switch (this.action) {
      case "total":
        this.doEmptyTotal();
        break;
      case "partiel":
        this.doEmptyPartiel();
        break;
    }
    this.showConfirm = false;
  }
  /**
   * methode de réindexation de la base de données
   */
  public reindexation() {
    this.$store.dispatch("login/setLoading", true);
    this.$store.dispatch("bdd/reindexation").then(
      (data: any) => {
        this.setSuccess(this.$t("ReindexOk").toString());
        this.$store.dispatch("login/setLoading", false);
      },
      (error: any) => {
        this.notifyError(error);
        this.$store.dispatch("login/setLoading", false);
      }
    );
  }
  /**
   * methode d'affichage du dialogue de choix du chemin du fichier de sauvegarde
   */
  public restaure() {
    this.action = "restaure";
    this.validated = false;
    this.showCodeDial = true;
  }
  /**
   * methode de validation du vidage de la bdd
   */
  public vidage() {
    this.commError = false;
    this.siteError = false;
    if (this.action === "partiel" && this.vidagePartielData.site === -1) {
      this.siteError = true;
      return;
    }
    if (this.vidagePartielData.commentaire === "") {
      this.commError = true;
      return;
    }
    this.showVidagePartiel = false;
    this.showConfirm = true;
  }
  /**
   * methode d'affichage du dialogue de choix du chemin du fichier de sauvegarde
   */
  public save() {
    this.action = "save";
    this.chooseFile = true;
  }
  /**
   * methode de validation du chemin de fichier de sauvegarde
   */
  public validateData() {
    if (this.action === "restaure") {
      this.doRestaure();
    } else {
      this.doSave();
    }
  }

  private chooseRestaure() {
    this.$store.dispatch("bdd/getBackupFiles", this.restaureData.path).then(
      (data: any) => {
        // console.log(data);
        this.files = data.data;
        this.chooseFileExisting = true;
      },
      (error: any) => {
        this.notifyError(error);
        this.$store.dispatch("login/setLoading", false);
      }
    );
  }
  /**
   * methode de restauration d'un fichier pour la base de données
   */
  private doRestaure() {
    console.log(this.restaureData);
    this.$store.dispatch("login/setLoading", true);
    this.$store.dispatch("bdd/restoreDataBase", this.restaureData).then(
      (data: any) => {
        this.setSuccess(this.$t("RestaureOk").toString());
        this.$store.dispatch("login/setLoading", false);
      },
      (error: any) => {
        this.notifyError(error);
        this.$store.dispatch("login/setLoading", false);
      }
    );
  }
  /**
   * methode de sauvegarde de la base de données
   */
  private doSave() {
    console.log(this.restaureData);
    this.$store.dispatch("login/setLoading", true);
    this.$store.dispatch("bdd/backup", this.restaureData).then(
      (data: any) => {
        console.log(data);
        if (data.data.code === 0) {
          this.setErrorFromTxt(data.data.response);
        } else {
          this.setSuccess(this.$t("SaveOk").toString());
        }
        this.$store.dispatch("login/setLoading", false);
      },
      (error: any) => {
        this.notifyError(error);
      }
    );
  }
  /**
   * methode de vidage total de la base de données
   */
  private doEmptyTotal() {
    this.$store.dispatch("login/setLoading", true);
    this.$store.dispatch("bdd/empty", this.vidagePartielData.commentaire).then(
      (data: any) => {
        this.setSuccess(this.$t("EmptyOk").toString());
        this.showVidagePartiel = false;
        this.$store.dispatch("login/setLoading", false);
      },
      (error: any) => {
        this.notifyError(error);
        this.$store.dispatch("login/setLoading", false);
      }
    );
  }
  /**
   * methode de vidage partiel de la base de données
   */
  private doEmptyPartiel() {
    this.$store.dispatch("login/setLoading", true);
    this.$store.dispatch("bdd/emptyPartiel", this.vidagePartielData).then(
      (data: any) => {
        this.setSuccess(this.$t("EmptyPartielOk").toString());
        this.showVidagePartiel = false;
        this.$store.dispatch("login/setLoading", false);
      },
      (error: any) => {
        this.notifyError(error);
        this.$store.dispatch("login/setLoading", false);
      }
    );
  }
  /**
   * notification d'erreur
   */
  private notifyError(error: any) {
    let message;
    if (error.message) {
      message = error.message;
    } else {
      message = this.$t("error").toString();
    }
    this.setErrorFromTxt(error.toString());
    this.$store.dispatch("login/setLoading", false);
  }

  get sites(): Site[] {
    return this.$store.getters["login/sites"];
  }
}
